/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ContractDownloadDtoFromJSON, ContractDtoFromJSON, DownloadContractDtoToJSON, FascicoloDtoFromJSON, IdentificationiResponseDtoFromJSON, IntesiAddRegistrationRequestToJSON, IntesiAddRegistrationResponseFromJSON, IntesiApproveRegistrationRequestToJSON, IntesiApproveRegistrationResponseFromJSON, IntesiCompleteRegistrationRequestToJSON, IntesiCompleteRegistrationResponseFromJSON, IntesiGenerateSecurePinRequestToJSON, IntesiGenerateTicketRequestToJSON, IntesiGenerateTicketResponseFromJSON, IntesiLinkResponseFromJSON, IntesiListCredentialsRequestToJSON, IntesiListCredentialsResponseFromJSON, IntesiPushOtpRequestToJSON, IntesiPushOtpResponseFromJSON, IntesiResponseDtoFromJSON, IntesiRevokeCertificateRequestToJSON, IntesiRevokeCertificateResponseFromJSON, IntesiSecurePinResponseFromJSON, IntesiUploadDocumentRequestToJSON, IntesiUploadDocumentResponseFromJSON, SumsubResponseDtoFromJSON, SumsubResponseDtoToJSON, SumsubTokenResponseFromJSON, UpdateContractRequestToJSON, } from '../models';
/**
 *
 */
export class ContractApi extends runtime.BaseAPI {
    /**
     */
    addRegistrationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.intesiAddRegistrationRequest === null || requestParameters.intesiAddRegistrationRequest === undefined) {
                throw new runtime.RequiredError('intesiAddRegistrationRequest', 'Required parameter requestParameters.intesiAddRegistrationRequest was null or undefined when calling addRegistration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/intesi/addRegistration`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: IntesiAddRegistrationRequestToJSON(requestParameters.intesiAddRegistrationRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntesiAddRegistrationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    addRegistration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.addRegistrationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    approveRegistrationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.intesiApproveRegistrationRequest === null || requestParameters.intesiApproveRegistrationRequest === undefined) {
                throw new runtime.RequiredError('intesiApproveRegistrationRequest', 'Required parameter requestParameters.intesiApproveRegistrationRequest was null or undefined when calling approveRegistration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/intesi/approveRegistration`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: IntesiApproveRegistrationRequestToJSON(requestParameters.intesiApproveRegistrationRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntesiApproveRegistrationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    approveRegistration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.approveRegistrationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    completeRegistrationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.intesiCompleteRegistrationRequest === null || requestParameters.intesiCompleteRegistrationRequest === undefined) {
                throw new runtime.RequiredError('intesiCompleteRegistrationRequest', 'Required parameter requestParameters.intesiCompleteRegistrationRequest was null or undefined when calling completeRegistration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/intesi/completeRegistration`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: IntesiCompleteRegistrationRequestToJSON(requestParameters.intesiCompleteRegistrationRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntesiCompleteRegistrationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    completeRegistration(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.completeRegistrationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    downloadContractRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.downloadContractDto === null || requestParameters.downloadContractDto === undefined) {
                throw new runtime.RequiredError('downloadContractDto', 'Required parameter requestParameters.downloadContractDto was null or undefined when calling downloadContract.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/contract/downloadContract`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DownloadContractDtoToJSON(requestParameters.downloadContractDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ContractDownloadDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    downloadContract(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.downloadContractRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    generateContractRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.idPratica === null || requestParameters.idPratica === undefined) {
                throw new runtime.RequiredError('idPratica', 'Required parameter requestParameters.idPratica was null or undefined when calling generateContract.');
            }
            const queryParameters = {};
            if (requestParameters.idPratica !== undefined) {
                queryParameters['idPratica'] = requestParameters.idPratica;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/contract/generateContract`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FascicoloDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    generateContract(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.generateContractRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    generateTicketRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.intesiGenerateTicketRequest === null || requestParameters.intesiGenerateTicketRequest === undefined) {
                throw new runtime.RequiredError('intesiGenerateTicketRequest', 'Required parameter requestParameters.intesiGenerateTicketRequest was null or undefined when calling generateTicket.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/intesi/generateTicket`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: IntesiGenerateTicketRequestToJSON(requestParameters.intesiGenerateTicketRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntesiGenerateTicketResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    generateTicket(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.generateTicketRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getContractSchemaRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/contract/getContractSchema`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     */
    getContractSchema(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContractSchemaRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getIdentificationUrlRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.idPratica === null || requestParameters.idPratica === undefined) {
                throw new runtime.RequiredError('idPratica', 'Required parameter requestParameters.idPratica was null or undefined when calling getIdentificationUrl.');
            }
            if (requestParameters.type === null || requestParameters.type === undefined) {
                throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getIdentificationUrl.');
            }
            const queryParameters = {};
            if (requestParameters.idPratica !== undefined) {
                queryParameters['idPratica'] = requestParameters.idPratica;
            }
            if (requestParameters.type !== undefined) {
                queryParameters['type'] = requestParameters.type;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/contract/getIdentificationLink`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntesiLinkResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    getIdentificationUrl(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getIdentificationUrlRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    identificationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.idPratica === null || requestParameters.idPratica === undefined) {
                throw new runtime.RequiredError('idPratica', 'Required parameter requestParameters.idPratica was null or undefined when calling identification.');
            }
            const queryParameters = {};
            if (requestParameters.idPratica !== undefined) {
                queryParameters['idPratica'] = requestParameters.idPratica;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/contract/identification`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IdentificationiResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    identification(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.identificationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    listCredentialsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.intesiListCredentialsRequest === null || requestParameters.intesiListCredentialsRequest === undefined) {
                throw new runtime.RequiredError('intesiListCredentialsRequest', 'Required parameter requestParameters.intesiListCredentialsRequest was null or undefined when calling listCredentials.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/intesi/listCredentials`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: IntesiListCredentialsRequestToJSON(requestParameters.intesiListCredentialsRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntesiListCredentialsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    listCredentials(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listCredentialsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    pushOtpRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.intesiPushOtpRequest === null || requestParameters.intesiPushOtpRequest === undefined) {
                throw new runtime.RequiredError('intesiPushOtpRequest', 'Required parameter requestParameters.intesiPushOtpRequest was null or undefined when calling pushOtp.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/intesi/pushOtp`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: IntesiPushOtpRequestToJSON(requestParameters.intesiPushOtpRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntesiPushOtpResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    pushOtp(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.pushOtpRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    pushOtp1Raw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.idPratica === null || requestParameters.idPratica === undefined) {
                throw new runtime.RequiredError('idPratica', 'Required parameter requestParameters.idPratica was null or undefined when calling pushOtp1.');
            }
            const queryParameters = {};
            if (requestParameters.idPratica !== undefined) {
                queryParameters['idPratica'] = requestParameters.idPratica;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/contract/pushOtp`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntesiPushOtpResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    pushOtp1(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.pushOtp1Raw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    revokeCertificateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.intesiRevokeCertificateRequest === null || requestParameters.intesiRevokeCertificateRequest === undefined) {
                throw new runtime.RequiredError('intesiRevokeCertificateRequest', 'Required parameter requestParameters.intesiRevokeCertificateRequest was null or undefined when calling revokeCertificate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/intesi/revokeCertificate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: IntesiRevokeCertificateRequestToJSON(requestParameters.intesiRevokeCertificateRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntesiRevokeCertificateResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    revokeCertificate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.revokeCertificateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    securePinRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.intesiGenerateSecurePinRequest === null || requestParameters.intesiGenerateSecurePinRequest === undefined) {
                throw new runtime.RequiredError('intesiGenerateSecurePinRequest', 'Required parameter requestParameters.intesiGenerateSecurePinRequest was null or undefined when calling securePin.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/intesi/securePin`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: IntesiGenerateSecurePinRequestToJSON(requestParameters.intesiGenerateSecurePinRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntesiSecurePinResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    securePin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.securePinRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfLoginRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.idPratica === null || requestParameters.idPratica === undefined) {
                throw new runtime.RequiredError('idPratica', 'Required parameter requestParameters.idPratica was null or undefined when calling selfLogin.');
            }
            const queryParameters = {};
            if (requestParameters.idPratica !== undefined) {
                queryParameters['idPratica'] = requestParameters.idPratica;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/contract/selfLogin`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SumsubTokenResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfLogin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfLoginRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    signContractRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.idPratica === null || requestParameters.idPratica === undefined) {
                throw new runtime.RequiredError('idPratica', 'Required parameter requestParameters.idPratica was null or undefined when calling signContract.');
            }
            if (requestParameters.otp === null || requestParameters.otp === undefined) {
                throw new runtime.RequiredError('otp', 'Required parameter requestParameters.otp was null or undefined when calling signContract.');
            }
            const queryParameters = {};
            if (requestParameters.idPratica !== undefined) {
                queryParameters['idPratica'] = requestParameters.idPratica;
            }
            if (requestParameters.otp !== undefined) {
                queryParameters['otp'] = requestParameters.otp;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/contract/signContract`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntesiResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    signContract(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.signContractRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    spidCheckRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ticket === null || requestParameters.ticket === undefined) {
                throw new runtime.RequiredError('ticket', 'Required parameter requestParameters.ticket was null or undefined when calling spidCheck.');
            }
            const queryParameters = {};
            if (requestParameters.ticket !== undefined) {
                queryParameters['ticket'] = requestParameters.ticket;
            }
            if (requestParameters.err !== undefined) {
                queryParameters['err'] = requestParameters.err;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/contract/spidCheck`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    spidCheck(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.spidCheckRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    sumsubWebhookRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sumsubResponseDto === null || requestParameters.sumsubResponseDto === undefined) {
                throw new runtime.RequiredError('sumsubResponseDto', 'Required parameter requestParameters.sumsubResponseDto was null or undefined when calling sumsubWebhook.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/contract/sumsubWebhook`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SumsubResponseDtoToJSON(requestParameters.sumsubResponseDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SumsubResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    sumsubWebhook(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.sumsubWebhookRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    updateContractRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.contractGroupId === null || requestParameters.contractGroupId === undefined) {
                throw new runtime.RequiredError('contractGroupId', 'Required parameter requestParameters.contractGroupId was null or undefined when calling updateContract.');
            }
            const queryParameters = {};
            if (requestParameters.contractId !== undefined) {
                queryParameters['contractId'] = requestParameters.contractId;
            }
            if (requestParameters.contractName !== undefined) {
                queryParameters['contractName'] = requestParameters.contractName;
            }
            if (requestParameters.contractDescription !== undefined) {
                queryParameters['contractDescription'] = requestParameters.contractDescription;
            }
            if (requestParameters.tipoDocumento !== undefined) {
                queryParameters['tipoDocumento'] = requestParameters.tipoDocumento;
            }
            if (requestParameters.contractGroupId !== undefined) {
                queryParameters['contractGroupId'] = requestParameters.contractGroupId;
            }
            if (requestParameters.hasSignature !== undefined) {
                queryParameters['hasSignature'] = requestParameters.hasSignature;
            }
            if (requestParameters.isFillable !== undefined) {
                queryParameters['isFillable'] = requestParameters.isFillable;
            }
            if (requestParameters.isSpending !== undefined) {
                queryParameters['isSpending'] = requestParameters.isSpending;
            }
            if (requestParameters.contractSchema !== undefined) {
                queryParameters['contractSchema'] = requestParameters.contractSchema;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/contract/updateContract`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateContractRequestToJSON(requestParameters.updateContractRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ContractDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    updateContract(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateContractRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    updateContractGroupRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.contractGroupId !== undefined) {
                queryParameters['contractGroupId'] = requestParameters.contractGroupId;
            }
            if (requestParameters.groupName !== undefined) {
                queryParameters['groupName'] = requestParameters.groupName;
            }
            if (requestParameters.groupDescription !== undefined) {
                queryParameters['groupDescription'] = requestParameters.groupDescription;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/contract/updateContractGroup`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     */
    updateContractGroup(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateContractGroupRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    uploadDocumentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.intesiUploadDocumentRequest === null || requestParameters.intesiUploadDocumentRequest === undefined) {
                throw new runtime.RequiredError('intesiUploadDocumentRequest', 'Required parameter requestParameters.intesiUploadDocumentRequest was null or undefined when calling uploadDocument.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/intesi/uploadDocument`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: IntesiUploadDocumentRequestToJSON(requestParameters.intesiUploadDocumentRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntesiUploadDocumentResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    uploadDocument(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.uploadDocumentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
